import React from 'react'
import PropTypes from 'prop-types'
import AvatarItem from './AvatarItem'

const AvatarGrid = ({ avatars, selectedAvatarId, onAvatarSelect }) => {
  return (
    <div className="grid grid-cols-3 gap-2 px-2 overflow-auto">
      {avatars?.map((avatar) => (
        <AvatarItem
          key={avatar.id}
          avatar={avatar}
          isSelected={selectedAvatarId === avatar.id}
          onSelect={onAvatarSelect}
        />
      ))}
    </div>
  )
}

AvatarGrid.propTypes = {
  avatars: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      img: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedAvatarId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onAvatarSelect: PropTypes.func.isRequired
}

export default AvatarGrid
